function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1388",
  "data-name": "Group 1388",
  transform: "translate(-89 -217)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Component_34_7",
  "data-name": "Component 34 \\u2013 7",
  transform: "translate(196.509 253.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#618a2e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#618a2e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#618a2e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1385",
  "data-name": "Group 1385",
  transform: "translate(-84.5 -32)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1384",
  "data-name": "Group 1384",
  transform: "translate(321 251)"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_96_",
  transform: "translate(0 16.751)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_688_",
  d: "M21.4,44.662H16.192a8.109,8.109,0,0,1-6.514-3.35L1.489,28.47a3.268,3.268,0,0,1-.744-.931,4.632,4.632,0,0,1-.186-4.653L4.467,15.07.372,10.975A1.573,1.573,0,0,1,0,9.858,1.024,1.024,0,0,1,.931,9.3H16.006a1.024,1.024,0,0,1,.931.558l5.77,13.959a1.231,1.231,0,0,1-.186,1.117,1.231,1.231,0,0,1-1.117.186L17.5,23.259,15.076,28.1h6.142a.879.879,0,0,1,.931.931V43.918C22.334,44.1,21.962,44.662,21.4,44.662ZM4.467,29.587l6.7,10.423a5.935,5.935,0,0,0,5.025,2.606h4.281V29.587H4.653C4.653,29.773,4.653,29.587,4.467,29.587Zm-1.489-2.42a3.144,3.144,0,0,0,1.861.558h8.375l3.164-6.514a1.068,1.068,0,0,1,1.3-.372l2.42,1.117L15.448,10.789H3.164l2.978,2.978a.877.877,0,0,1,.186,1.117L2.233,23.631a2.984,2.984,0,0,0,.186,2.792c0,.186.186.186.186.372l.372.372Z",
  transform: "translate(0 -9.3)",
  fill: "#618a2e"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_97_",
  transform: "translate(35.362 34.229)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_687_",
  d: "M23.281,34.714h-3.35a.931.931,0,1,1,0-1.861h3.35a5.935,5.935,0,0,0,5.025-2.606L36.681,19.08A.931.931,0,1,1,38.17,20.2L29.795,31.364A8.109,8.109,0,0,1,23.281,34.714Z",
  transform: "translate(-19 -18.691)",
  fill: "#618a2e"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_98_",
  transform: "translate(35.362 20.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_684_",
  d: "M28.12,28.084H19.931a.931.931,0,0,1,0-1.861h6.328l-5.211-8c-.186-.186-.186-.372-.186-.744a.594.594,0,0,1,.558-.558l11.167-5.584a1.234,1.234,0,0,1,1.3.372L39.1,21.012A4.725,4.725,0,0,1,34.82,27.9l-6.7.186Zm.372-1.861h6.142a3.181,3.181,0,0,0,2.42-1.3,2.984,2.984,0,0,0,.186-2.792l-4.653-8.561L23.095,18.22Z",
  transform: "translate(-19 -11.261)",
  fill: "#618a2e"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_107_",
  transform: "translate(9.306 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_680_",
  d: "M37.571,20.773h0L24.356,18.912a.8.8,0,0,1-.744-.744,1.422,1.422,0,0,1,.372-.931L27.706,15l-2.978-4.281L19.7,18.353a1.068,1.068,0,0,1-1.3.372L5.372,11.281C5.186,11.095,5,10.909,5,10.723a1.119,1.119,0,0,1,.186-.744l5.025-6.7A7.144,7.144,0,0,1,15.981.3H31.429a5.82,5.82,0,0,1,4.653,2.42L38.873,7l3.908-2.047a.877.877,0,0,1,1.117.186c.372.372.186.558.186.931L38.5,20.028A1.237,1.237,0,0,1,37.571,20.773Zm-10.236-3.35,9.678,1.3L41.479,7.745l-2.42,1.3a.9.9,0,0,1-1.117-.372l-3.35-4.839a3.657,3.657,0,0,0-3.164-1.675H21.192A5.017,5.017,0,0,1,22.5,3.65L29.94,14.631a1.119,1.119,0,0,1,.186.744c0,.186-.186.558-.372.558Zm-20.1-7.259,11.353,6.514,5.025-7.817L20.634,4.581a5.482,5.482,0,0,0-4.467-2.42,5.647,5.647,0,0,0-4.653,2.233Z",
  transform: "translate(-5 -0.3)",
  fill: "#618a2e"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_108_",
  transform: "translate(25.963 30.709)"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_679_",
  d: "M24.28,41a1.411,1.411,0,0,1-.744-.372L14.229,30.387a.7.7,0,0,1,0-1.117l9.306-12.1c.186-.372.744-.372,1.117-.372a1.024,1.024,0,0,1,.558.931v4.653a.879.879,0,0,1-.931.931,1,1,0,0,1-.931-.931V20.522l-7.072,9.306,7.072,7.817V35.412a.931.931,0,0,1,1.861,0v4.653a1.024,1.024,0,0,1-.558.931C24.466,40.809,24.466,41,24.28,41Z",
  transform: "translate(-13.95 -16.8)",
  fill: "#618a2e"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1383",
  "data-name": "Group 1383",
  transform: "translate(-78 -122.592)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678",
  transform: "translate(168 340.592)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M252.959-165.605c0-3.1-2.949-5.613-6.584-5.613H218.608c-3.634,0-6.584,2.515-6.584,5.613V-129.7c0,3.1,2.95,5.613,6.584,5.613h27.767c3.635,0,6.584-2.515,6.584-5.613Z",
  transform: "translate(-212.024 177.654)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-172.117H246.1v-6.333H220.819Z",
  transform: "translate(-212.992 178.45)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-115.221H246.1v-1.585H220.819Z",
  transform: "translate(-212.992 171.284)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h40.68",
  transform: "translate(-212.04 176.563)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h40.68",
  transform: "translate(-212.04 172.437)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_517",
  "data-name": "Path 517",
  d: "M232.159-149.994s4.449,6.844,4.449,9.3a4.451,4.451,0,0,1-4.449,4.449,4.452,4.452,0,0,1-4.45-4.449C227.709-143.15,232.159-149.994,232.159-149.994Z",
  transform: "translate(-43.691 514.129)",
  fillRule: "evenodd"
})));

var SvgStartRecycling = function SvgStartRecycling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203.5,
    height: 58.063,
    viewBox: "0 0 203.5 58.063",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartRecycling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/start_recycling.b1c53aac.svg";
export { ForwardRef as ReactComponent };